<template>
    <div class="new-workList">
        <div class="container">
            <template v-if="JSON.stringify(query) == '{}'">
                <mc-layout-row label-text="站点名" :label-width="170" important>
                    <el-select style="width:100%" v-model="formValue.site_id" placeholder='请选择站点' @change="$_getAlertList">
                        <el-option v-for='item in siteList' :key="item.site_id" :label="item.site_name" :value="item.site_id">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="告警内容" :label-width="170">
                    <el-select style="width:100%" v-model="formValue.alert_id" placeholder='请选择告警内容' @change="$_selectAlert">
                        <el-option v-for='item in alertList' :key="item.alert_id" :label="item.alert_content" :value="item.alert_id">
                        </el-option>
                    </el-select>
                </mc-layout-row>
            </template>
            <template v-else>
                <mc-layout-row label-text="站点名" :label-width="170" important>
                    <mc-label info>{{formValue.site_name}}</mc-label>
                </mc-layout-row>
                <mc-layout-row label-text="告警内容" :label-width="170" important>
                    <mc-label info>{{formValue.alert_content}}</mc-label>
                </mc-layout-row>
            </template>

            <div class="line"></div>

            <mc-layout-row label-text="工单标题" :label-width="170" important>
                <el-input v-model="formValue.name" clearable placeholder="请输入工单标题"></el-input>
            </mc-layout-row>
            <mc-layout-row label-text="事件类型" :label-width="170" important>
                <el-select style="width:100%" v-model="formValue.problem_type" placeholder='请选择事件类型'>
                    <el-option v-for='item in formData.problem_type' :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </mc-layout-row>
            <mc-layout-row label-text="工单类型" :label-width="170" important>
                <el-select style="width:100%" v-model="formValue.server_type" placeholder='请选择工单类型'>
                    <el-option v-for='item in formData.server_type' :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </mc-layout-row>

            <div class="line"></div>

            <mc-layout-row label-text="工单记录" :label-width="170" align-column="top">
                <el-input type="textarea" v-model="formValue.content" rows='3' placeholder="请输入备注"></el-input>
            </mc-layout-row>
            <mc-layout-row label-text="上传附件" :label-width="170" content-align-row="left" align-column="top">
                <el-button size="small" style="padding:13px 15px" type="primary" @click="$_fileButton"><i class="el-icon-upload2"></i>上传文件</el-button>
                <mc-label info style="margin-left: 10px" icon="el-icon-warning" warn>支持扩展名：.rar .zip .doc .docx .pdf .jpg...</mc-label>
                <input v-show="false" type="file" class='selectfile' @change='$_handleFileChange' ref='selectfile' />
            </mc-layout-row>
            <div class="line"></div>
            <mc-layout-row label-text="新上传附件" :label-width="170" v-if="!fileName.length"><mc-label info></mc-label></mc-layout-row>
            <mc-layout-row label-text="新上传附件" :label-width="170" v-for="(item, index) in fileName" :key="index" :label-show='!index' content-align-row="right">
                <div style="width:515px" class="upload-transition">
                    <mc-label info style="position:relative" class="upload-item" icon="el-icon-document">
                        <span>{{ item }}</span>
                        <i class="el-icon-close icon-item" @click="$_deleteUploadItem(index)"></i>
                    </mc-label>
                </div>
            </mc-layout-row>

            <div class="line"></div>

            <mc-layout-row :label-show="false">
                <el-button type="primary" @click="setUp" style="margin-right: 10px;">立即创建</el-button>
                <el-button @click="cancel">取消</el-button>
            </mc-layout-row>
        </div>
    </div>
</template>

<script>
    import SparkMD5 from 'spark-md5'

    export default {
        name: "user-new-workList",
        data() {
            return {
                formData: {
                    problem_type: [{
                            label: '其他',
                            value: '1',
                        }, {
                            label: '网络',
                            value: '2',
                        },
                        {
                            label: '存储',
                            value: '3',
                        },
                        {
                            label: '服务器',
                            value: '4',
                        },
                        {
                            label: '中间件',
                            value: '5',
                        },
                        {
                            label: '数据库',
                            value: '6',
                        },
                        {
                            label: '操作系统',
                            value: '7',
                        },
                        {
                            label: '硬件故障',
                            value: '8',
                        },
                    ],
                    server_type: [{
                            label: '故障处理',
                            value: '1',
                        },
                        {
                            label: '配置变更',
                            value: '2',
                        },
                        {
                            label: '配件更换',
                            value: '3',
                        },
                        {
                            label: '健康巡检',
                            value: '4',
                        },
                    ],
                },
                formValue: {
                    name: '',
                    alert_content: '',
                    alert_id: '',
                    site_id: '',
                    site_name: '',
                    problem_type: '',
                    server_type: '1',
                    content: '',
                    source: []
                },
                siteList: [],
                alertList: [],
                query: {},
                md5: '',
                fileId: [],
                fileName: [],
            }
        },
        created() {
            // this.$_getSiteList();
            this.$_init();
        },
        methods: {
            $_init: async function () {
                if (this.$route.query.site_id) {
                    await this.$_getSiteList();
                    this.$_getQuery();
                } else {
                    await this.$_getSiteList();
                }
            },
            $_getQuery: async function () {
                let query = this.$route.query
                if (JSON.stringify(query) == '{}') {
                    return false
                } else {
                    this.query = query
                    this.formValue.site_id = query.site_id
                    this.formValue.alert_id = query.alert_id
                    await this.$_getAlertList(query.site_id)
                    this.$_selectAlert(query.alert_id)
                }
            },
            setUp: async function () {
                let params = this.formValue
                let data = await this.$api.userNewWorkList.getList.creat.call(this, params);
                if (data !== false) {
                    this.$message.success('创建成功!')
                    this.$router.push({
                        name: 'user-process-workList',
                    });
                }
            },
            cancel() {
                this.$router.back();
            },
            $_getSiteList: async function () {
                let params = {}
                let data = await this.$api.userNewWorkList.getList.getSiteList.call(this, params);
                if (data !== false) {
                    this.siteList = data;
                    // this.$_getQuery();
                }
            },
            $_getAlertList: async function (item) {
                let params = {
                    site_id: item
                }
                let data = await this.$api.userNewWorkList.getList.getAlertList.call(this, params);
                if (data !== false) {

                    this.alertList = data
                    let obj = {};
                    obj = this.siteList.find((value) => {
                        return value.site_id == item;
                    });
                    this.formValue.site_name = obj.site_name
                }
            },
            $_selectAlert(item) {

                let obj = {};
                obj = this.alertList.find((value) => {
                    return value.alert_id == item;
                });
                // debugger
                this.formValue.alert_content = obj.alert_content
            },
            $_getFileList: async function (file) {
                let formData = new FormData();
                formData.append("key", file.key);
                formData.append("p1", file.p1);
                formData.append("p2", file.p2);
                formData.append("file", this.$refs.selectfile.files[0]);
                let data = await this.$api.userNewWorkList.getList.getFileList.call(this, formData);
                if (data !== false) {
                    this.fileId.push(data)
                    this.formValue.source = this.fileId
                    this.fileName.push(this.$refs.selectfile.files[0].name)
                    // this.$_getQuery();
                }
            },
            $_uploadFile: async function (file) {
                let params = {
                    0: {
                        filename: file.name,
                        md5: this.md5
                    }
                }
                let data = await this.$api.userNewWorkList.getList.upload.call(this, params);
                if (data !== false) {
                    this.$_getFileList(data[0])
                }
            },
            //上传文件代码
            $_handleFileChange() {
                let inputDom = this.$refs.selectfile;
                this.postFile(inputDom)
            },
            $_fileButton() {
                this.$refs.selectfile.click();
            },
            postFile(input) {
                let that = this
                //这里需要用到File的slice( )方法，以下是兼容写法
                var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
                    file = input.files[0],
                    chunkSize = 2097152, // 以每片2MB大小来逐次读取
                    chunks = Math.ceil(file.size / chunkSize),
                    currentChunk = 0,
                    spark = new SparkMD5(), //创建SparkMD5的实例
                    time,
                    fileReader = new FileReader();

                fileReader.onload = function (e) {

                    spark.appendBinary(e.target.result); // append array buffer
                    currentChunk += 1;

                    if (currentChunk < chunks) {
                        loadNext();
                    } else {
                        running = false;
                        that.md5 = spark.end()
                        that.$_uploadFile(input.files[0])
                    }
                };

                fileReader.onerror = function () {
                    running = false;
                };

                function loadNext() {
                    var start = currentChunk * chunkSize,
                        end = start + chunkSize >= file.size ? file.size : start + chunkSize;

                    fileReader.readAsBinaryString(blobSlice.call(file, start, end));
                }

                let running = true;
                loadNext();
            },
            $_deleteUploadItem(index) {
                this.fileId.splice(index,1);
                this.fileName.splice(index,1);
            }
        }
    }
</script>

<style lang="less" scoped>
    .new-workList {
        width: 100%;
        display: inline-block;

        .container {
            width: 800px;
            padding-top: 40px;
            padding-bottom: 40px;
            padding-left: 125px;

            .box-row {
                width: 100%;
                height: 60px;
                line-height: 60px;
                display: flex;

                .form-item {
                    width: 170px;
                    height: 40px;
                    margin: 10px 20px 10px;
                    padding: 0 20px;
                    line-height: 40px;
                    font-size: 14px;
                    color: #909399;
                    background-color: #f5f7fa;
                    border: 1px solid #dcdfe6;
                    border-radius: 4px;
                }
            }

            .box-row-text {
                width: 100%;
                height: auto;
                display: flex;

                .form-content {
                    width: 100%;
                    margin: 10px 0;
                }
            }

            .form-upload {
                width: 100%;
            }
        }

        .box-btn {
            margin-top: 50px;
            margin-left: 170px;
        }

        .line {
            width: 100%;
            height: 1px;
            margin: 20px 0;
            background-color: #eeeeee;
        }

        .upload-item:hover {
            color: #1890FF;
        }

        .icon-item {
            position:absolute;
            right:10px;
            cursor:pointer;
        }

        .upload-transition {
            animation: fade .5s; 
            -webkit-animation: fade .5s;
            position: relative;
        }
        @keyframes fade {
            0% { opacity: 0; transform: translateY(-30px); }
            100% { opacity: 1; transform: translateY(0); }
        }
    }
</style>